<template>
    <div class="container">
        <iframe
            :src="src"
            allowtransparency="true"
            allow="geolocation; microphone; camera"
            frameborder="0"
            scrolling="auto"
            allowfullscreen
            @load="onLoad"
        />
        <v-overlay :absolute="false" v-if="loading">
            <v-progress-circular indeterminate size="50" color="primary" />
        </v-overlay>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },
        passImplicitParams: {
            type: Boolean,
            default: false,
        },
        staticParams: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: true,
        }
    },
    computed: {
        src() {
            let params = this.staticParams
            if (this.passImplicitParams) {
                // If passImplicitParams is true, pass implicit user parameters and the response ID.
                const { name, email, employeeId } = this.$store.getters[
                    'auth/getUser'
                ]
                const firstName = name.split(' ')[0]
                const lastName = name.split(' ').pop()
                params = {
                    ...params,
                    name,
                    'name[first]': firstName,
                    'name[last]': lastName,
                    email,
                    employeeId,
                }
            }
            let url = new URL(this.url)
            Object.keys(params).map((key) =>
                url.searchParams.append(key, params[key])
            )
            return url.toString()
        },
    },
    methods: {
        onLoad() {
            this.loading = false
        },
    },
}
</script>

<style scoped>
div.container {
    width: 100%;
    height: 100%;
}
iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
